import SignInPage from "./SignUpPage";

export default SignInPage;
